/*
 * Cart page sticky checkout bar visibility.
 * Hides the mobile sticky bar while the real in-card "Secure checkout" button
 * (#checkout) is on screen, and shows it again once that button scrolls out of
 * view. Scroll-based (re-queries each frame) so it keeps working after Dawn
 * re-renders the cart contents on a quantity change.
 */
(function () {
  function update() {
    var bar = document.querySelector('[data-cart-sticky-bar]');
    if (!bar) return;
    var checkout = document.getElementById('checkout');
    if (!checkout) {
      bar.classList.remove('cart-page__sticky-checkout--hidden');
      return;
    }
    var rect = checkout.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    var inView = rect.bottom > 0 && rect.top < viewport;
    bar.classList.toggle('cart-page__sticky-checkout--hidden', inView);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      update();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  // re-evaluate after the cart section re-renders (qty change) or in the editor
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', update);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
